import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** Admin-only: how long an Invitation link stays valid, for the invite hint (#21). */
export function useInviteSettings(options?: {
  enabled?: boolean;
}): UseQueryResult<{ invitationLinkHours: number }> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.inviteSettings(),
    queryFn: () => client.getInviteSettings(),
    enabled: options?.enabled ?? true,
    staleTime: Infinity,
  });
}
